<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xl3 lg4 md5 sm6>
        <v-layout row wrap justify-center>
          <v-flex xs5 class="mb-4">
            <v-img
              contain
              min-width="120px"
              :src="require('@/assets/allsight-logo1-light.png')"
            ></v-img>
          </v-flex>
          <v-flex>
            <v-card class="elevation-12">
              <v-layout>
                <v-flex>
                  <v-card-title primary-title>
                    <v-layout row align-center justify-center>
                      <v-flex md7>
                        <object
                          width="100%"
                          :data="require('@/assets/elsight-light-logo3.svg')"
                        ></object>
                      </v-flex>
                      <v-flex>
                        <h4 class="display-1 primary--text text-center">
                          {{ $t("modules.resetPassword.title") }}
                        </h4>
                      </v-flex>
                    </v-layout>
                  </v-card-title>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
              <v-card-text>
                <v-form
                  v-if="!submitted && !tokenExpired"
                  @keyup.native.enter="reset_password()"
                  ref="resetPasswordForm"
                >
                  <v-text-field
                    required
                    clearable
                    :label="$t('modules.resetPassword.password')"
                    v-model="credentials.password"
                    :type="showPassword ? 'text' : 'password'"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPassword = !showPassword"
                    :rules="[
                      v =>
                        !!v ||
                        $t('validation.required', [
                          $t('modules.resetPassword.password')
                        ]),
                      ...passwordRegexRules
                    ]"
                    prepend-icon="mdi-lock"
                    id="resetPassword__form-password"
                  >
                    <template v-slot:message="{ message, key }">
                      <div
                        v-html="message"
                        :key="key"
                        class="custom_error_message"
                      ></div>
                    </template>
                  </v-text-field>
                  <v-text-field
                    required
                    clearable
                    :label="$t('modules.resetPassword.environment')"
                    v-model="credentials.environment_name"
                    prepend-icon="mdi-domain"
                    id="resetPassword__form-environment"
                    :rules="[
                      v =>
                        !!v ||
                        $t('validation.required', [
                          $t('modules.resetPassword.environment')
                        ])
                    ]"
                  ></v-text-field>
                  <v-card-actions>
                    <v-btn
                      :loading="loading"
                      @click="reset_password()"
                      block
                      color="primary"
                      id="resetPassword__form-button"
                    >
                      {{ $t("modules.resetPassword.resetPasswordOperation") }}
                    </v-btn>
                  </v-card-actions>
                </v-form>
                <div v-if="submitted">
                  <span>Password reset successfully</span>
                  <v-btn
                    :loading="loading"
                    @click="back_to_login_page()"
                    id="goBackToLogin__form-button"
                  >
                    <v-icon>mdi-keyboard-backspace</v-icon>
                    {{
                      $t("modules.forgotPassword.goBackToLoginPageOperation")
                    }}
                  </v-btn>
                </div>
                <div v-if="tokenExpired">
                  <span>
                    Oops, this link is expired
                    <br />
                    <br />This URL is not valid anymore.
                  </span>
                  <br />
                  <br />
                  <v-btn
                    :loading="loading"
                    @click="back_to_login_page()"
                    id="goBackToLogin__form-button"
                  >
                    <v-icon>mdi-keyboard-backspace</v-icon>
                    {{
                      $t("modules.forgotPassword.goBackToLoginPageOperation")
                    }}
                  </v-btn>
                </div>
              </v-card-text>
              <v-snackbar
                multi-line
                color="error"
                v-model="error.invalidToken.shown"
                :timeout="error.invalidToken.timeout"
                id="reset__snackbar-error-invalidToken"
              >
                {{ $t("error.resetTokenInvalid") }}
                <template v-slot:action="{ attr }">
                  <v-btn
                    text
                    @click="error.invalidToken.shown = false"
                    v-bind="attr"
                  >
                    {{ $t("modules.login.closeOperation") }}
                  </v-btn>
                </template>
              </v-snackbar>
              <v-snackbar
                multi-line
                color="error"
                v-model="error.credentials.shown"
                :timeout="error.credentials.timeout"
                id="login__snackbar-error-credentials"
              >
                {{ $t("modules.login.error.credentials") }}
                <template v-slot:action="{ attr }">
                  <v-btn
                    text
                    @click="error.credentials.shown = false"
                    v-bind="attr"
                  >
                    {{ $t("modules.login.closeOperation") }}
                  </v-btn>
                </template>
              </v-snackbar>
              <v-snackbar
                multi-line
                color="error"
                v-model="error.environment.shown"
                :timeout="error.environment.timeout"
                id="login__snackbar-error-environment"
              >
                {{ $t("modules.login.error.environment") }}
                <template v-slot:action="{ attr }">
                  <v-btn
                    text
                    @click="error.environment.shown = false"
                    v-bind="attr"
                  >
                    {{ $t("modules.login.closeOperation") }}
                  </v-btn>
                </template>
              </v-snackbar>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {
  UserCredentialsError,
  UserEnvironmentError
} from "@/modules/login/util";
import { userMixins } from "@/modules/users/mixins";

export default {
  name: "ForgotPasswordPage",
  mixins: [userMixins],
  data() {
    return {
      showPassword: false,
      submitted: false,
      loading: false,
      credentials: {
        email: "",
        environment_name: ""
      },
      error: {
        credentials: {
          shown: false,
          timeout: 0
        },
        environment: {
          shown: false,
          timeout: 0
        },
        invalidToken: {
          shown: false,
          timeout: 0
        }
      },
      tokenExpired: false
    };
  },
  created() {
    if (this.$store.state.login.isLoggedIn === true) {
      this.$store.dispatch("login/logout");
    }
    this.$store
      .dispatch("resetPassword/checkUserToken", this.user_token)
      .then(response => {
        // Proceed to the remaining password reset workflow
      })
      .catch(error => {
        // show password reset token
        this.tokenExpired = true;
      });
  },

  methods: {
    reset_password() {
      if (this.$refs.resetPasswordForm.validate()) {
        this.loading = true;
        this.error.credentials.shown = false;
        this.error.environment.shown = false;
        this.error.invalidToken.shown = false;

        const credentials = {
          password: this.credentials.password,
          environment_name: this.credentials.environment_name,
          user_token: this.user_token
        };

        this.$store
          .dispatch("resetPassword/submit", credentials)
          .then(response => {
            this.submitted = true;
          })
          .catch(error => {
            if (error instanceof UserCredentialsError) {
              this.error.credentials.shown = true;
            } else if (error instanceof UserEnvironmentError) {
              this.error.environment.shown = true;
            } else {
              this.error.invalidToken.shown = true;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    back_to_login_page() {
      this.$router.push({ name: "login" });
    }
  },
  computed: {
    user_token() {
      return this.$route.params["user_token"];
    }
  }
};
</script>

<style>
.custom_error_message {
  line-height: 16px;
}
</style>
